import { Component, OnInit, TemplateRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { UserService } from '../../services/user.service';
import { ApplicationsService } from '../../services/applications.service';
import { LocalService } from '../../services/local.service';
import * as Globals from '../../../core/globals';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Output() loggedOut = new EventEmitter();

  username: String;
  password: String;
  loggedin: Boolean;
  is_superuser: any;
  apps: any = [];
  regemail: String;
  applicationList: any = [];
  applist: any;
  name: string = '';
  email: string = '';
  image: string = null;
  loggedUserName: string = '';
  demo = Globals.demo;
  user_type: string;
  constructor(
    public applicationService: ApplicationsService,
    public loginservice: LoginService,
    public userservice: UserService,
    public router: Router,
    public localService: LocalService,
    ) {
      this.user_type = this.localService.getJsonValue('user_type')
  }

  ngOnInit() {
    console.log(this.localService.getJsonValue('is_superuser'))
    this.loggedin = (this.localService.getJsonValue('isLoggedin') ? true : false);
    this.is_superuser = (this.localService.getJsonValue('is_superuser') ? true : false);
    if (this.loggedin) {
      this.name = this.localService.getJsonValue('name');
      this.email = this.localService.getJsonValue('email');
      this.image = this.localService.getJsonValue('image');
      this.fetchApps();
    }
  }

  logout() {
    this.userservice.logout().subscribe(
      response => {
      },
      error => {
        // console.log(error)
      }
    );
    this.loggedin = false;
    // added by Shubhadeep for EDMS
    // Date - 18 Feb 2021
    if (this.localService.getJsonValue('edms_url')) {
      let edms_url = this.localService.getJsonValue('edms_url');
      let logout_url = edms_url.toString().split('authentication')[0] + 'authentication/logout/';
      console.log(logout_url);
      this.applicationService.logoutEdmsToken(logout_url).subscribe(
        response => {
          this.localService.clearToken();
          this.router.navigate(['/login']);
        },
        error => {
          this.localService.clearToken();
          this.router.navigate(['/login']);
        }
      );
    } else {
      this.localService.clearToken();
      this.router.navigate(['/login']);
    }
  }


  fetchApps() {
    this.applicationList = [];
    if (this.is_superuser == true || this.is_superuser == "true") {
      this.applicationService.applicationList().subscribe(
        response => {
          this.apps = response;
          this.apps.forEach(element => {
            this.applicationList.push({
              'module': element,
              'permissions': {
                'cp_g': 7,
                'cp_o': 7,
                'cp_u': 7
              }
            });
          });
          // console.log(this.applicationList)
          this.appNameChange();          
        },
        error => {
          // console.log(error)
        }
      );
    } else {
      this.applist = JSON.parse(this.localService.getJsonValue("module_access"));
      this.applist.forEach(element => {
        this.applicationList.push({
          'module': element.module,
          'permissions': element.permissions
        });
      });
      this.appNameChange();          
    }
  }

  goLanding() {
    this.router.navigate(['/landing'])
  }

  goAdmin() {
    this.router.navigate(['/admin/applications'])
  }

  goPage(moduledet) {
    this.localService.setJsonValue("currentModuleId", moduledet.id)
    localStorage.setItem("currentModuleId", moduledet.id)
    window.open(location.origin + location.pathname + "/" + moduledet.cm_url, "_self");
  }

  goSpecialPage(moduledet) {
    var userStr = this.localService.getJsonValue('loggedUserName');
    var officialEmailStr = this.localService.getJsonValue('officialEmail');
    var userNewStr = btoa(userStr);
    var officialEmailNewStr = btoa(officialEmailStr);
    if (moduledet.cm_url == 'crm') {
      var url = "https://shyamsteel.tech/crm/admin/auth/" + officialEmailNewStr;
      window.open(url, "_self");
    }
    else if (moduledet.cm_url == 'tms') {
      var url = "http://13.232.240.233:8001/login/" + userNewStr;
      window.open(url, "_self");
    }
  }

  goprofile() {
    this.router.navigate(['/account'])
  }

  gopass() {
    this.router.navigate(['/account/changepassword'])
  }

  appNameChange(){
    this.applicationList.map(e =>{
      if(e.module && e.module.cm_name){
        if(e.module.cm_name == 'E-Task'){
          e.module.cm_name = 'SFTware Works';
        } else if (e.module.cm_name == 'VMS'){
          e.module.cm_name = 'SFTware Queue';
        } else if (e.module.cm_name == 'PMS'){
          e.module.cm_name = 'SFTware Contract';
        } else if (e.module.cm_name == 'SFT CRM'){
          e.module.cm_name = 'SFTware Sales (CRM)';
        }
      }
    })
  }
}
